// extracted by mini-css-extract-plugin
export default {"container":"videos_container__Qgx-G","newVideosContainer":"videos_newVideosContainer__kaPSe","textDraw":"videos_textDraw__B915s"};